import axios from '@/axios'
import API from '@/API'

const PREFIX = 'imei_assignment'

export default {
  datatable(params) {
    return axios.get(`${API.endpoint}/${PREFIX}/datatable`, {
      params: params
    })
  },
  import(data) {
    return axios.post(`${API.endpoint}/${PREFIX}/import`, data)
  },
  delete(id) {
    return axios.post(`${API.endpoint}/${PREFIX}/delete/${id}`)
  },
}